import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AccountUserService } from 'src/app/service/account.service';
import { Observable } from 'rxjs';
import { SubTask } from '../../models/sub-task/add-subTask.model';

// import { environment } from
// './  ../../../environments/environment';
// import { AccountUserService } from 'src/app/service/account.service';

@Injectable({
  providedIn: 'root'
})
export class SharedTaskService {

  appUrl = "";
  apiUrl = ""
  activity = "";
  apiUrlLogin = "";
  activityUrl = "";
  user: any;
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.appUrl = environment.localApiUrl;
    this.apiUrl = environment.apiUrl;
    this.activity = environment.activity;
    this.apiUrlLogin = environment.apiUrlLogin;
    this.activityUrl = environment.activity + '/LionO360/2.0/API/';
  }


  getUsers(organizationId: number) {
    return this.http.get<any>(environment.appOrgUrl + `User?organizationId=${organizationId}`)
      .toPromise()
      .then(res => res);
  }

  getReminderTypes() {
    return this.http.get<any>(this.appUrl + "reminderTypes")
      .toPromise()
      .then(res => res);
  }

  getReminderDelays() {
    return this.http.get<any>(this.appUrl + "reminderDelays")
      .toPromise()
      .then(res => res);
  }

  getOccurrences() {
    return this.http.get<any>(this.apiUrl + "Occurence/GetAllOccurence")
      .toPromise()
      .then(res => res);
  }

  getPriorities() {
    return this.http.get<any>(this.appUrl + "priority")
      .toPromise()
      .then(res => res);
  }

  getTaskStatuses() {
    return this.http.get<any>(this.activityUrl + "Status?groupId=3")
      .toPromise()
      .then(res => res);
  }

  getTaskStatus(statusId) {
    return this.http.get<any>(this.apiUrl + "Status/" + statusId)
      .toPromise()
      .then(res => res);
  }

  addActivityTask(task) {
    return this.http.post(this.apiUrl + "ObjectTask", task)
      .toPromise()
      .then(res => res);
  }

  updateActivityTask(task) {
    return this.http.put(this.activityUrl + "Task/Status", task)
      .toPromise()
      .then(res => res);
  }

  //#region Implementation of (Re-write)and new functionality of Create Task
  newAddTask(task): Observable<any>{
    return this.http.post<any>(`${this.activityUrl}ObjectTask`, task)
  }

  markCheckedList(checkListId: any){
    return this.http.put<any>(`${this.activityUrl}Task/TaskCheckList`, checkListId
    )
  }

  addSubTask(subTaskData: SubTask[]){
    return this.http.post<any>(`${this.activityUrl}Task/SubTask`,subTaskData);
  }

  updateSubTask(subTaskData: SubTask){
    return this.http.put<any>(`${this.activityUrl}Task/SubTask`,subTaskData);
  }

  getTaskDefaultValues(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/TaskDefaultValue`)
  }

  allTaskPriorityList(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/TaskPriority`)
  }

}
